import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import "../styles/TeacherDashboard.css";
import TeacherDemographicReport from "../components/TeacherDemographicReport";
import home from "../images/home.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import history from "../images/history.png";
import tutorials from "../images/tutorials.png";

const TeacherDemographicReportPage = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  //   const [showUploadForm, setShowUploadForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const teacherMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
    { icon: history, label: "History", key: "history", disabled: true },
  ];



  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    }
    resetSearch(); // Reset search whenever a new section is selected
  };

  // Determine which parts of the header to show based on the active menu item
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        searchQuery={searchQuery}
        showUserProfile={showUserProfile}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        />
        <div className="content"><TeacherDemographicReport /></div>
      </main>
    </div>
  );
};

export default TeacherDemographicReportPage;
